import { Commands } from '.';
var ClientClose = (function () {
    function ClientClose(sender, controller, action) {
        if (controller === void 0) { controller = 'WebMapViewManager'; }
        if (action === void 0) { action = 'QueryClose'; }
        this.myController = controller;
        this.myAction = action;
        this.myArgs = { ViewId: sender.model.UniqueID };
    }
    Object.defineProperty(ClientClose.prototype, "controller", {
        get: function () {
            return this.myController;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientClose.prototype, "args", {
        get: function () {
            return this.myArgs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientClose.prototype, "action", {
        get: function () {
            return this.myAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClientClose.prototype, "name", {
        get: function () {
            return Commands.ClientCloseCommand;
        },
        enumerable: false,
        configurable: true
    });
    return ClientClose;
}());
export { ClientClose };
